import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import { inject as service } from '@ember/service';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import CustomFormsService from 'cio/services/custom-forms';
import { all } from 'rsvp';

export default class SegmentsRoute extends Route {
  @service facebookLeadAds!: FacebookLeadAdsService;
  @service customForms!: CustomFormsService;

  crumb() {
    return {
      name: 'Segments',
      path: 'segments',
      helpLabel: 'segments',
      helpUrl: 'https://learn.customer.io/getting-started/creating-segments.html',
    };
  }

  async beforeModel(transition: Transition) {
    await all([this.facebookLeadAds.initialize(), this.customForms.initialize()]);

    return super.beforeModel(transition);
  }
}
